<template>
  <div class="v-floor">
    <slot
      v-if="floorInfoList.length"
      :floor-info-list="floorInfoList"
      :floor-nick-name-list="floorNickNameList">
    </slot>
  </div>
</template>

<script>
  export default {
    props: {
      channelName: {
        type: String
      },
      floorNameList: {
        type: Array,
        default: () => []
      },
      otherParams: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        floorInfoList: [],
        floorNickNameList: []
      };
    },
    mounted() {
      this.$http.post(
        '/currMaterielFloor',
        {
          channelName: this.channelName || window.CONFIG.floor.channelName,
          floorNameList: this.floorNameList,
          ...this.otherParams
        },
        {
          isError: false
        }
      ).then((resData) => {
        if (resData.resultData.result.code === '0000') {
          const resultData = resData.resultData;
          this.floorInfoList = resultData.floorInfoList;
          this.floorNickNameList = resultData.floorNickNameList;
          this.$emit('info', this.floorInfoList, this.floorNickNameList);
        }
      });
    }
  };
</script>